import api from './client';

export interface TeamMember {
  id: number;
  name: string;
  email: string;
  role: 'owner' | 'admin' | 'member' | 'viewer';
  role_label: string;
  role_description: string;
  status: 'pending' | 'active' | 'suspended';
  status_label: string;
  is_owner: boolean;
  is_active: boolean;
  is_pending: boolean;
  is_invitation_expired: boolean;
  invited_by: string | null;
  accepted_at: string | null;
  last_active_at: string | null;
  created_at: string;
}

export const teamApi = {
  list: () => api.get<{ data: TeamMember[] }>('/team'),

  invite: (data: { name: string; email: string; role: string }) =>
    api.post<{ data: TeamMember }>('/team/invite', data),

  resendInvite: (id: number) =>
    api.post<{ data: TeamMember }>(`/team/${id}/resend-invite`),

  updateRole: (id: number, role: string) =>
    api.patch<{ data: TeamMember }>(`/team/${id}/role`, { role }),

  suspend: (id: number) =>
    api.patch<{ data: TeamMember }>(`/team/${id}/suspend`),

  reactivate: (id: number) =>
    api.patch<{ data: TeamMember }>(`/team/${id}/reactivate`),

  remove: (id: number) =>
    api.delete<{ data: null }>(`/team/${id}`),
};

export const INVITABLE_ROLES = [
  { value: 'admin',  label: 'Admin',  description: 'Can manage audits, AI features, and team members.' },
  { value: 'member', label: 'Member', description: 'Can run audits and use AI features, cannot manage team.' },
  { value: 'viewer', label: 'Viewer (read-only)', description: 'Read-only access to audit results and reports.' },
];
